import Module from '../../Module';
import mock from './mock';
import { Cover, Gallery, Node } from '../';

class ProductService extends Module {
  get baseURL() {
    return '/api/v1/products'
  }

  initMock(handler) {
    mock(this.handler)
  }

  parseProducts(products) {
    return products.map(product => {
      return this.parseProduct(product);
    })
  }

  /**
   * parse product
   * @param {Object} product 
   */
  parseProduct(product) {
    return {
      active: product.active,
      allBarcode: product.allBarcode,
      appName: product.appName,
      barcode: product.barcode,
      brand: product.brand,
      brandId: product.brandId,
      consumerPrice: product.consumerPrice,
      coverId: product.coverId,
      createdAt: product.createdAt,
      currentDiscount: product.currentDiscount,
      currentPrice: product.currentPrice,
      deletedAt: product.deletedAt,
      departmentCode: product.departmentCode,
      departmentId: product.departmentId,
      departmentName: product.departmentName,
      description: product.description,
      discountFlag: product.discountFlag,
      discountGroupId: product.discountGroupId,
      discountGroupName: product.discountGroupName,
      externalId: product.externalId,
      gallery: product.gallery,
      height: product.height,
      id: product.id,
      languageId: product.languageId,
      lastPrice: product.lastPrice,
      name: product.appName && product.appName !== "" ? product.appName : product.name,
      nameInPos: product.nameInPos,
      parentId: product.parentId,
      parentNodes: product.parentNodes,
      productType: product.productType,
      quantity: product.quantity,
      reportGroupId: product.reportGroupId,
      reportGroupName: product.reportGroupName,
      reserved: product.reserved,
      status: product.status,
      statusId: product.statusId,
      stockId: product.stockId,
      storeId: product.storeId,
      supplierId: product.supplierId,
      supplierName: product.supplierName,
      taxGroupId: product.taxGroupId,
      taxGroupName: product.taxGroupName,
      taxPercent: product.taxPercent,
      taxable: product.taxable,
      typeId: product.typeId,
      unitType: product?.unitType,
      limitBuyQuantity:product.limitBuyQuantity,
      unitOdMeasure: product.unitOdMeasure,
      updatedAt: product.updatedAt,
      weight: product.weight,
      width: product.width,
      consumerPrice: product.consumerPrice,
      cover: product.cover ? Cover.parseCover(product.cover) : null,
    }
  }

  parseSearchNodes(nodes) {
    if (!nodes) return [];

    return nodes.map(node => {
      return this.parseSearchNode(node);
    })
  }

  parseSearchNode(node) {
    return {
      id: node.id,
      childrenType: node.ownerType,
      category: {
        title: node.title
      }
    }
  }

  // parseBarcodeScannerProducts(products) {
  //   if (!products) return [];

  //   return products.map(product => {
  //     return this.parseProduct(product);
  //   })
  // }

  /**
   * product detail
   * @param {Any} id 
   */
  getProductDetail(id, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/${id}`, {
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              product: this.parseProduct(data.product)
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }

  getGallery(id, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/${id}/gallery`, {
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              cover: Cover.parseCover(data.cover),
              gallery: Gallery.parseGallery(data.gallery),
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }

  getResultSearch(params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}`, {
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              products: Node.parseNodes(data.nodes),
              nodes: this.parseSearchNodes(data.parents)
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }

  getResultSearchBarcode(barcode, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/barcode/${barcode}`, {
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              products: Node.parseNodes(data.products),
              // products: Node.parseNodes(data.products),
              // nodes: this.parseSearchNodes(data.parents)
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }
}

export default new ProductService()
